import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { naira } from "../../lib/format";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import { CheckCircle2 } from "lucide-react";
import { C } from "./AccountingLayout";
import { toast } from "sonner";

export default function Reconciliation() {
  const [shifts, setShifts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [tab, setTab] = useState("cash");

  useEffect(() => {
    api.get("/pos/shifts").then(setShifts).catch(() => {});
    api.get("/orders").then(setOrders).catch(() => {});
  }, []);

  const mark = async (orderId, idx) => {
    try { await api.post(`/reconciliation/payments/${orderId}/${idx}/mark-reconciled`); toast.success("Marked"); api.get("/orders").then(setOrders).catch(() => {}); } catch (e) { toast.error("Failed"); }
  };
  const unrec = (method) => orders.flatMap((o) => (o.payments || []).map((p, idx) => ({ ...p, orderId: o.id, orderNumber: o.number, customer: o.customer_name, date: o.date, idx }))).filter((p) => p.method === method && !p.reconciled);

  return (
    <div className="space-y-4" data-testid="reconciliation-page">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList><TabsTrigger value="cash" data-testid="tab-cash">Cash (Shifts)</TabsTrigger><TabsTrigger value="card" data-testid="tab-card">Card</TabsTrigger><TabsTrigger value="transfer" data-testid="tab-transfer">Transfer</TabsTrigger></TabsList>
        <TabsContent value="cash">
          <div className="rounded-xl bg-white border overflow-hidden" style={{ borderColor: C.border }}>
            <table className="w-full text-sm">
              <thead><tr className="text-left text-[10px] uppercase tracking-widest border-b" style={{ color: C.softMuted, borderColor: C.borderSoft }}><th className="py-3 px-4">Cashier</th><th className="py-3 px-3">Till</th><th className="py-3 px-3">Opened</th><th className="py-3 px-3 text-right">Expected</th><th className="py-3 px-3 text-right">Counted</th><th className="py-3 px-4 text-right">Variance</th></tr></thead>
              <tbody>{shifts.length === 0 ? <tr><td colSpan={6} className="py-8 text-center" style={{ color: C.softMuted }}>No shifts closed yet.</td></tr> : shifts.map((s, i) => (
                <tr key={i} className="border-b" style={{ borderColor: C.borderSoft }}>
                  <td className="py-2.5 px-4 font-semibold" style={{ color: C.text }}>{s.cashier_name}</td>
                  <td className="py-2.5 px-3">{s.till}</td>
                  <td className="py-2.5 px-3 text-[12px]" style={{ color: C.muted }}>{(s.opened_at || "").slice(0, 16).replace("T", " ")}</td>
                  <td className="py-2.5 px-3 text-right tabular-nums">{naira(s.expected_cash || 0)}</td>
                  <td className="py-2.5 px-3 text-right tabular-nums">{naira(s.counted_cash || 0)}</td>
                  <td className="py-2.5 px-4 text-right tabular-nums font-brand font-bold" style={{ color: (s.variance || 0) === 0 ? C.green : Math.abs(s.variance || 0) < 500 ? C.amber : C.red }}>{naira(s.variance || 0)}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        </TabsContent>
        {["card", "transfer"].map((method) => (
          <TabsContent key={method} value={method}>
            <div className="rounded-xl bg-white border overflow-hidden" style={{ borderColor: C.border }}>
              <table className="w-full text-sm">
                <thead><tr className="text-left text-[10px] uppercase tracking-widest border-b" style={{ color: C.softMuted, borderColor: C.borderSoft }}><th className="py-3 px-4">Order</th><th className="py-3 px-3">Customer</th><th className="py-3 px-3">Date</th><th className="py-3 px-3 text-right">Amount</th><th className="py-3 px-4"></th></tr></thead>
                <tbody>{unrec(method).length === 0 ? <tr><td colSpan={5} className="py-8 text-center" style={{ color: C.softMuted }}>All {method} payments reconciled.</td></tr> : unrec(method).map((p, i) => (
                  <tr key={i} className="border-b" style={{ borderColor: C.borderSoft }}>
                    <td className="py-2.5 px-4 font-semibold" style={{ color: C.burgundy }}>{p.orderNumber}</td>
                    <td className="py-2.5 px-3">{p.customer}</td>
                    <td className="py-2.5 px-3 text-[12px]" style={{ color: C.muted }}>{(p.date || "").slice(0, 10)}</td>
                    <td className="py-2.5 px-3 text-right tabular-nums font-brand font-bold" style={{ color: C.text }}>{naira(p.amount)}</td>
                    <td className="py-2.5 px-4 text-right"><button onClick={() => mark(p.orderId, p.idx)} className="text-[12px] font-semibold flex items-center gap-1 ml-auto" style={{ color: C.green }}><CheckCircle2 size={13} /> Reconcile</button></td>
                  </tr>
                ))}</tbody>
              </table>
            </div>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
